var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStyleOneBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 37302",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 21659",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5 27.5H.5V.5h35v27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1v26h34V1H1M0 0h36v28H0V0Z",
    fill: "#185edf"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17414",
    fill: "#185edf",
    d: "M4 4h28v20H4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleOneBlue);
export default __webpack_public_path__ + "static/media/Style_One_blue.0e042f5913693326ab2ac75919ab82c0.svg";
export { ForwardRef as ReactComponent };